import script from "./UsersListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersListPage.vue?vue&type=script&setup=true&lang=js"

import "./UsersListPage.vue?vue&type=style&index=0&id=77a1deae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a1deae"]])

export default __exports__